<template>
  <router-link :to="option?.tabsLink || option?.link || ''">
    <side-menu-item
      :active="activeTab === tab"
      class="m-0 pl-7 leading-4"
      is-slim
    >
      <span class="text-xs">
        {{ tab }}
      </span>
    </side-menu-item>
  </router-link>
</template>
<script setup lang="ts">
import SideMenuItem from "@/components/ui/SideMenuItem.vue";

import type { ISidebarSubmenuOption } from "@/models/common";

defineProps<{
  option: ISidebarSubmenuOption;
  tab: string;
  activeTab: string;
}>();
</script>
